'use client'
import useAppStore from '@/context/app-context';
import { useEffect } from 'react';

/**
 * 客户端标题更新组件
 * 在应用配置加载后动态更新页面标题
 */
export const HeadUpdater = () => {
  const { appInfo, loading } = useAppStore();

  useEffect(() => {
    // 当应用配置加载完成且有标题时更新页面标题
    if (!loading && appInfo?.title) {
      const envPrefix = process.env.NODE_ENV !== 'production' 
        ? process.env.NODE_ENV.substring(0, 3).toUpperCase() + ' ' 
        : '';
      
      document.title = `${envPrefix}${appInfo.title}`;
    }
  }, [appInfo, loading]);

  return null;
};